import {DatePipe} from '@angular/common';
import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

/**
 * @author ozaytunctan
 * @version 2.0
 *
 *  Her seferinde çağrılsın bir değişiklik algılandığında.
 *  Mesela dil değiştiğinde parametreler güncellenmez ama içerdeki dil değiştiğinden false olarak ayarlandıki her seferinde kontrol etsin.
 */
@Pipe({
    name: 'localizedDate',
    pure: false,
  standalone: false
  }
)
export class LocalizedDatePipe implements PipeTransform {
  static defaultTimezone:string="+0300";

  constructor(
    private translateService: TranslateService,
    private datePipe: DatePipe
  ) {
  }

  /**
   *
   * @param value
   * @param format
   */
  transform(value: Date | string | number, format: string = 'mediumDate',useClientTimezone:boolean=false): any {
    if (value)
      return this.datePipe.transform(
        value,
        format,
        useClientTimezone ? undefined : LocalizedDatePipe.defaultTimezone,
        this.translateService.currentLang
      );
  }
}
